import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../../../../store/store';
import { utilities } from '../../../../../../util/utilities';
import { datosEmpresa, empresa, listaEmpresasUsuario } from '../../../../../../models/empresas/empresas.models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { editarEmpresasUsuario, guardarEmpresasUsuario, obtenerEmpresas, obtenerEstatusEmpresas, obtenerListaEmpresasUsuario } from '../../../../../../actions/empresas/empresas.actions';
import { Alerta } from '../../../../../../helpers/alerts/alert';

export type EmpresasFormProps = {
	onComplete: (estaCompleto: boolean) => void;
	idUsuarioElsa: number;
	accion: string;
}

const EmpresasForm: React.FC<EmpresasFormProps> = ({ onComplete, idUsuarioElsa, accion }) => {
	//const empresas = useSelector((store: AppStore) => store.empresas.empresas);
	const [cargando, setCargando] = useState(false);
	const [empresas, setEmpresas ] = React.useState<empresa[]>([]);
	const [mostrarCargando, setMostrarCargando] = useState(true);
	const [empresasSeleccionadas, setEmpresasSeleccionadas] = useState<empresa[]>([]);
	const [datosUsuario, setDatosUsuario] = useState({
		idUsuarioElsa: idUsuarioElsa,
		empresaRegistrada: false,
		empresas: []
	});
	const [listaEmpresasUsuario, setListaEmpresasUsuario] = useState<listaEmpresasUsuario[]>([]);

	const { empresaRegistrada } = datosUsuario;

	function seleccionarEmpresa(opcion: empresa) {
		if (empresasSeleccionadas.map((e)=>e.idEmpresa).includes(opcion.idEmpresa)) {
			setDatosUsuario((prev: any) => ({
				...prev,
				empresas: empresasSeleccionadas.filter(empresa => empresa.idEmpresa !== opcion.idEmpresa)
			}))

			setEmpresasSeleccionadas(empresasSeleccionadas.filter(empresa => empresa.idEmpresa !== opcion.idEmpresa));
		} else {
			setDatosUsuario((prev: any) => ({
				...prev,
				empresas: [...empresasSeleccionadas, opcion]
			}))
			setEmpresasSeleccionadas([...empresasSeleccionadas, opcion]);
		}
	}

	function editarListaEmpresasFunction(empresa: listaEmpresasUsuario) {
		setListaEmpresasUsuario((prev) => {
			return prev.map((datos) => {
				if (datos.idEmpresa === empresa.idEmpresa) {
					return {
						...datos,
						seleccionadaPorUsuario: !datos.seleccionadaPorUsuario
					}
				}
				return datos;
			})
		})
	}

	function validarListaEmpresas() {
		let esValido: boolean = true;

		if (empresasSeleccionadas.length < 1) {
			esValido = false;
		}

		return {
			esValido
		}
	};

	function validarListaEmpresasEditar() {
		let esValido: boolean = true;

		if (!empresasSeleccionadas.length) {
			esValido = false;
			Alerta("Debes seleccionar al menos una empresa", false);
		}

		return {
			esValido
		}
	}

	function checkearEmpresasSeleccionadas(empresa: any) {
		if (empresa.seleccionadaPorUsuario) {
			return true;
		} else {
			return false;
		}
	}

	async function obtenerEstatusEmpresasAsync() {
		try {
			setMostrarCargando(true);
			const respEmpresas = await obtenerEmpresas();
			let empresas: empresa[] = respEmpresas.data;
			setEmpresas(empresas)
			const resp = await obtenerEstatusEmpresas(idUsuarioElsa);
			if (resp.success) {
				setDatosUsuario((prev: any) => ({
					...prev,
					empresaRegistrada: resp.data.tieneEmpresaRegistrada
				}))

				let listaEmpresasUsuarioResponse: datosEmpresa[] = resp.data.empresas;
				const empresasEnRegistro =  (empresas||[]).filter(datos=>listaEmpresasUsuarioResponse.find(
					(empresa) => empresa.idEmpresa === datos.idEmpresa && !empresa.borrado 
				));
				setEmpresasSeleccionadas(empresasEnRegistro);
				const nuevaLista = (empresas||[]).map((datos) => {
					const empresaEnRegistro = listaEmpresasUsuarioResponse.find(
						(empresa) => empresa.idEmpresa === datos.idEmpresa
					);

					return empresaEnRegistro
						? {
							idEmpresa: empresaEnRegistro.idEmpresa,
							idEmpresaUsuario: empresaEnRegistro.idEmpresaUsuario,
							razonSocialEmpresa: empresaEnRegistro.razonSocialEmpresa,
							empresaPredeterminada: empresaEnRegistro.empresaPredeterminada,
							seleccionadaPorUsuario: !empresaEnRegistro.borrado,
							existeEnRegistro: true,
							logoEmpresa: empresaEnRegistro.logoEmpresa,
							imagenPortadaEmpresa: empresaEnRegistro.imagenPortadaEmpresa,
							colorPrincipal: empresaEnRegistro.colorPrincipal,
							colorSecundario: empresaEnRegistro.colorSecundario,
							colorTexto: empresaEnRegistro.colorTexto,
							telefonoOrigen: "",
							appID: "",
							privateKey: "",
							dominio: "",
							template: "",
							idDominio: 0
						}
						: {
							idEmpresa: datos.idEmpresa,
							idEmpresaUsuario: 0,
							razonSocialEmpresa: datos.razonSocialEmpresa,
							empresaPredeterminada: false,
							seleccionadaPorUsuario: false,
							existeEnRegistro: false,
							logoEmpresa: datos.logoEmpresa,
							imagenPortadaEmpresa: datos.imagenPortadaEmpresa,
							colorPrincipal: "",
							colorSecundario: "",
							colorTexto: "",
							telefonoOrigen: "",
							appID: "",
							privateKey: "",
							dominio: "",
							template: "",
							idDominio: 0
						};
				});
				setListaEmpresasUsuario(nuevaLista);

				onComplete(accion === "editar" ? false : resp.data.tieneEmpresaRegistrada);
			};

			setMostrarCargando(false)
			
		} catch(e) {
			console.log("error form Empresas", e);
			Alerta("Ocurrió un error al obtener las empresas, vuelve a iniciar sesión.", false)
		}
	}

	async function guardarEmpresasUsuarioAsync() {
		try {
			const { esValido } = validarListaEmpresas();
			if (esValido) {
				setCargando(true);
				const resp = await guardarEmpresasUsuario(datosUsuario);
				if (resp.success) {
					Alerta(resp.message, resp.success);
					onComplete(resp.success)
					setCargando(false);
					setDatosUsuario((prev: any) => ({
						...prev,
						empresaRegistrada: resp.success
					}))
				} else {
					Alerta(resp.message, resp.success);
					setCargando(false);
				}
			}
		} catch {
			console.error("Error")
		}
	};

	async function editarListaEmpresasUsuarioAsync() {
		const { esValido } = validarListaEmpresasEditar();
		try {

			if (esValido) {
				setCargando(true);
				const empresasSelececcionadasId = empresasSeleccionadas.map(item=>item.idEmpresa);
				
				const resp = await editarEmpresasUsuario({idUsuarioElsa: idUsuarioElsa, empresas: listaEmpresasUsuario.map((item)=>({ ...item, seleccionadaPorUsuario: empresasSelececcionadasId.includes(item.idEmpresa)  })) });
				if (resp.success) {
					Alerta(resp.message, true);
					setCargando(false);
				} else {
					Alerta(resp.message, false);
					setCargando(false);
				}
				
			}
		} catch (err) {
			console.error(err)
		}
	}

	useEffect(() => {
		obtenerEstatusEmpresasAsync();
	}, [])

	return (
		<div className='flex flex-col gap-5 '>
			
			{
				mostrarCargando ? (
					<div className='flex flex-col justify-center align-middle items-center p-5'>
						<span className="loading loading-spinner text-BlueDAR loading-lg"></span>
					</div>
				) : (
					<div className='flex flex-col gap-5'>
						<div className='flex flex-row flex-wrap gap-5'>
							{
								
								(empresas||[]).map((empresa, index) => (
											<div
												key={index}
												style={{
													flexBasis: "400px",
													...(empresa.imagenPortadaEmpresa !== ""
														? {
															backgroundImage: `url(${utilities.generaLigaImagen(empresa.imagenPortadaEmpresa)})`,
															backgroundSize: "cover",
															backgroundPosition: "center",
														}
														: {
															backgroundColor: "#f0f0f0",
														}),
												}}
												className='flex flex-col p-5 gap-2'
											>
												<div className='relative left-[95%] top-0'>
													<input
														type="checkbox"
														className={`checkbox checkbox-success ${empresa.imagenPortadaEmpresa !== "" ? 'border-white border-2' : 'border-black border-2'}`}
														checked={empresasSeleccionadas.includes(empresa)}
														onChange={() => seleccionarEmpresa(empresa)}
													/>
												</div>
												{
													empresa.logoEmpresa !== "" ? (
														<img src={utilities.generaLigaImagen(empresa.logoEmpresa)} alt="logoEmpresa" className='h-12 w-28' />
													) : (
														<img src={"https://cronos.gdar.mx/publico/assets/images/brand/logoDAR_Color.png"} alt="logoEmpresa" className='h-12 w-40' />
													)
												}
												<p className={`font-semibold pt-2 ${empresa.imagenPortadaEmpresa === '' ? 'text-black' : 'text-white'}`}>{empresa.razonSocialEmpresa}</p>
											</div>
								))
							}
						</div>
						<div className='flex justify-end'>
							<button
								className='btn btn-sm bg-BlueDAR '
								onClick={ editarListaEmpresasUsuarioAsync}
							>
								{
									cargando && (
										<div>
											<span className="loading loading-spinner loading-xs"></span>
										</div>
									)
								}
								<p className='text-white'>Guardar cambios</p>
							</button>
						</div>
					</div>
				)
			}
		</div >
	);
};

export default EmpresasForm;
